/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';


/**
 * API responsavel pelos dados do Relatório
 */
@Injectable({
  providedIn: 'root',
})
class RelatorioService extends __BaseService {
  static readonly obterRelatorioParcelaPath = '/relatorio/parcela';
  static readonly obterRelatorioAcordoPath = '/relatorio/acordo';
  static readonly obterRelatorioFinanceiroPath = '/relatorio/financeiro-conciliacao';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param params The `RelatorioService.ObterRelatorioParcelaParams` containing the following parameters:
   *
   * - `tipoDataPesquisa`:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `codigoStatus`: Codigo do status da parcela
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * @return Relatório gerado com sucesso
   */
  obterRelatorioParcelaResponse(params: RelatorioService.ObterRelatorioParcelaParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.tipoDataPesquisa != null) __params = __params.set('tipoDataPesquisa', params.tipoDataPesquisa.toString());
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.codigoStatus != null) __params = __params.set('codigoStatus', params.codigoStatus.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/relatorio/parcela`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param params The `RelatorioService.ObterRelatorioParcelaParams` containing the following parameters:
   *
   * - `tipoDataPesquisa`:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `codigoStatus`: Codigo do status da parcela
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * @return Relatório gerado com sucesso
   */
  obterRelatorioParcela(params: RelatorioService.ObterRelatorioParcelaParams): __Observable<Blob> {
    return this.obterRelatorioParcelaResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param params The `RelatorioService.ObterRelatorioAcordoParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `codigoStatus`: Codigo do status do acordo
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * @return Relatório gerado com sucesso
   */
  obterRelatorioAcordoResponse(params: RelatorioService.ObterRelatorioAcordoParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.codigoStatus != null) __params = __params.set('codigoStatus', params.codigoStatus.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/relatorio/acordo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param params The `RelatorioService.ObterRelatorioAcordoParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `codigoStatus`: Codigo do status do acordo
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * @return Relatório gerado com sucesso
   */
  obterRelatorioAcordo(params: RelatorioService.ObterRelatorioAcordoParams): __Observable<Blob> {
    return this.obterRelatorioAcordoResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param params The `RelatorioService.ObterRelatorioFinanceiroParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `codigoStatus`: Codigo do status do acordo
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * @return Relatório gerado com sucesso
   */
  obterRelatorioFinanceiroResponse(params: RelatorioService.ObterRelatorioFinanceiroParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ramoSinistro != null) __params = __params.set('ramoSinistro', params.ramoSinistro.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.codigoStatus != null) __params = __params.set('codigoStatus', params.codigoStatus.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/relatorio/financeiro-conciliacao`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Retorna relatorio de parcelas com base na lista de parcela passada
   * @param params The `RelatorioService.ObterRelatorioFinanceiroParams` containing the following parameters:
   *
   * - `ramoSinistro`: Codigo do ramo do sinistro
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `codigoStatus`: Codigo do status do acordo
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * @return Relatório gerado com sucesso
   */
  obterRelatorioFinanceiro(params: RelatorioService.ObterRelatorioFinanceiroParams): __Observable<Blob> {
    return this.obterRelatorioFinanceiroResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module RelatorioService {

  /**
   * Parameters for obterRelatorioParcela
   */
  export interface ObterRelatorioParcelaParams {
    tipoDataPesquisa?: number;

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Codigo do status da parcela
     */
    codigoStatus?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;
  }

  /**
   * Parameters for obterRelatorioAcordo
   */
  export interface ObterRelatorioAcordoParams {

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Codigo do status do acordo
     */
    codigoStatus?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;
  }

  /**
   * Parameters for obterRelatorioFinanceiro
   */
  export interface ObterRelatorioFinanceiroParams {

    /**
     * Codigo do ramo do sinistro
     */
    ramoSinistro?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Codigo do status do acordo
     */
    codigoStatus?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;
  }
}

export { RelatorioService }
